import { filterCompatibleFundingAccounts, getFundingRoutesGroupedByCurrency } from '@routable/fund-routes';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelectorWithProps } from 'hooks';
import { fundingAccountsForCompanyIdQuerySelector } from 'queries/fundingCompoundSelectors';
import { partnershipRequestFromLocationSelector } from 'selectors/partnershipRequestSelectors';
export const usePartnershipRequestFundingRoutes = () => {
    const location = useLocation();
    const fundingAccounts = useSelectorWithProps(fundingAccountsForCompanyIdQuerySelector, { location });
    const partnershipRequest = useSelectorWithProps(partnershipRequestFromLocationSelector, { location });
    const fundingRoutesByCurrency = useMemo(() => getFundingRoutesGroupedByCurrency(partnershipRequest.fundingRoutes), [partnershipRequest.fundingRoutes]);
    const acceptableFundingAccounts = useMemo(() => filterCompatibleFundingAccounts({ fundingRoutesByCurrency, fundingAccounts }), [fundingAccounts, fundingRoutesByCurrency]);
    return { acceptableFundingAccounts, fundingRoutes: partnershipRequest.fundingRoutes, fundingRoutesByCurrency };
};
